import { ReactElement, ReactNode } from 'react';
import { TIconProps } from '@/common/components/Icons/Icon';
import { IconBadge } from '@coverflex-tech/hypernova';
import cx from 'classnames';
import { css } from './TimelineSteps.css';

interface TTimelineStepsProps {
  items: {
    icon: ReactElement<TIconProps>;
    badgeClassName?: string;
    content: ReactNode;
  }[];
}

export const TimelineSteps = ({ items }: TTimelineStepsProps) => {
  return (
    <div className={css.host}>
      {items.map((item, idx) => (
        <div className={css.item} key={idx}>
          <IconBadge
            ratio={32}
            className={cx(css.itemBadge, item.badgeClassName)}
            icon={item.icon}
          />
          {item.content}
        </div>
      ))}
    </div>
  );
};
